import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify'; // Importation

function Bataillon() {
  const navigate = useNavigate();
  const [listeBataillon, setListBataillon] = useState([]);

  useEffect(() => {
    axios.get('/bataillon').then((res) => {
      setListBataillon(res.data);      
      setBataillons(res.data);
      setLoading(false);
    });
  }, []);

  const [bataillons, setBataillons] = useState([]);
  const [selectedBataillon, setSelectedBataillon] = useState('');
  const [loading, setLoading] = useState(true);

  const handleDelete = async (event) => {
    event.preventDefault();
    if (!selectedBataillon) {
      toast.warn('Veuillez sélectionner un bataillon.');
      return;
    }

    const confirmDeletion = async () => {
      try {
        const response = await axios.delete(`bataillon/${selectedBataillon}`);
        if (response.data.success) {
          toast.success('Suppression réussi !', {
            position: 'bottom-right',
          });
          setTimeout(() => {
            navigate('/bataillon');
          }, 2000);
        }
      } catch (error) {
        toast.error('Erreur de suppression de bataillon', {
          position: 'bottom-right',
        });
      }
    };
    const confirmToast = toast(
      <div>
        <p>Êtes-vous sûr de vouloir supprimer ce personnel ?</p>
        <button className="btn-info float-left " onClick={cancelDeletion}>
          Non
        </button>
        <button className="btn-danger float-right " onClick={confirmDeletion}>
          Oui
        </button>
      </div>,
      {
        autoClose: 3000, // Ne pas fermer automatiquement
        closeOnClick: false, // Ne pas fermer au clic
      }
    );

    function cancelDeletion() {
      toast.info('Suppression annulée.');
      // Logique d'annulation ici
    }
  };
 
  if (loading) {
    return (
      <div className="container  pt-3 ">
        <div className=" col text-center" style={{ textAlign: 'center', margin: '20px' }}>
          <img src="/images/laodinf-laoding.gif" alt="Chargement..." />
        </div>
      </div>
    );
  }
  return (
    <div className="container mt-3 ">
      <div className="row">
        <div className="col">
          <h2>Supprimer Personnels d'un Bataillon</h2>
          <form onSubmit={handleDelete}>
            <label htmlFor="bataillonSelect">Sélectionnez un Bataillon :</label>
            <select id="bataillonSelect" value={selectedBataillon} onChange={(e) => setSelectedBataillon(e.target.value)} className="form-control">
              <option value="">-- Sélectionnez un Bataillon --</option>
              {bataillons.map((bataillon) => (
                <option key={bataillon.id} value={bataillon.id}>
                  {bataillon.name}
                </option>
              ))}
            </select>

            <button className="btn btn-danger m-4  " type="submit">
              Supprimer
            </button>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div>
            <h1>Bataillon</h1>
          </div>
          <Link to="/creatbataillon">Nouveau Bataillon</Link>
          <table className="table table-border table-sm">
            <thead>
              <tr>
                <th>id</th>
                <th>Bataillon</th>
                <th>Libelle</th>
                <th>OBS</th>
                <th>Référence</th>
                <th>User</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {listeBataillon.map((bataillon, key) => {
                return (
                  <tr key={key}>
                    <td> {bataillon.id} </td>
                    <td>
                      {bataillon.name} ({bataillon.id})
                    </td>
                    <td> {bataillon.libelle} </td>
                    <td> {bataillon.observation} </td>
                    <td> {bataillon.reference} </td>
                    <td>
                      {bataillon.user?.username ? (
                        bataillon.user.username
                      ) : (
                        <span style={{ color: "red" }}>Aucun utilisateur</span>
                      )}
                    </td>
                    <td>
                      <i style={{ cursor: 'pointer' }} className="fa fa-pencil p-2" onClick={() => navigate(`/bataillon/edit/${bataillon.id}`)}></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Bataillon;
